import { post } from './utils'

export async function uploadFile(file) {
  const formData = new FormData()
  formData.append('file', file, file.name)
  const response = await post(Routes.api_v1_files_path(), formData)
  return response.data
}
